import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import shortid from 'shortid';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import './ToolTray.css';


import Checkbox from '../Checkbox/Checkbox.js'
import CustomField from '../CustomField/CustomField.js'
import PatternThumbnail from '../PatternThumbnail/PatternThumbnail.js'
import Tabs from '../Tabs/Tabs.js'

import officialCategories from '../../pattern_utilities/officialCategories.js'

import {
  tryToGetMyPatterns,
  setTrayOpen,
  showTooltip,
  hideTooltip 
} from '../../actions/actions.export.js';


import canI from '../../canI.js';

class ToolCalculatorTray extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      search: ''
    }

    this.escFunction = this.escFunction.bind(this);
  }


  escFunction(event){
    const { dispatch, globalReducer } = this.props;
    if(event.keyCode === 27 && globalReducer.trayOpen.calculators){
      dispatch(setTrayOpen({tray: "calculators", open: false} ))
    }
  }
  componentDidMount(){
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }

  render(){
    const { user, dispatch, globalReducer, patternManager, cacheID, team} = this.props;
    const that = this;


    function calculatorThumbnail(p, i, j, name){
      let preHeat = patternManager.pristineCache[p].projects.indexOf('Preheat') > -1;
      let canAccessTemplates = canI(user, team, 'calculator_access', team.current);

      let locked = false;
      let lockedMessage = "";

      if(!preHeat){
        if(canAccessTemplates){
          locked = false;
        } else {
          locked = true;
          lockedMessage = "Upgrade to Pro or create a team to use this template."
        }
      }

      return <div key={j + '-' + i} className="col-lg-2 col-md-3 col-sm-4 col-xs-6 theme-light">
        <small>
          {
            j === 0 ? <span className="text-primary">{name} <i className="fal fa-angle-right"/></span> : <span>&nbsp;</span>
          }
        </small>

        <PatternThumbnail 
          locked={locked}
          lockedMessage={lockedMessage} 
          template={true}
          cacheID={p} 
          official={true}
          onClick={(e)=> { 
            // dispatch(setTemplateModalOpen(false)) 
          }}
          />
      </div>
    }

    var hasSearchResults = false;
    for(var i in patternManager.officialCalculators){
      var p = patternManager.officialCalculators[i];
      if(patternManager.pristineCache[p].name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1){
        hasSearchResults = true;
        break;
      }
    }


    patternManager.officialCalculators.sort((a,b)=>{
      let pa = patternManager.pristineCache[a];
      let pb = patternManager.pristineCache[b];

      if(pa.projects.indexOf('Preheat') > -1 && pb.projects.indexOf('Preheat') === -1) return -1;
      if(pa.projects.indexOf('Preheat') === -1 && pb.projects.indexOf('Preheat') > -1) return 1;
      return 0;
    })


    return <div className={"tool-pattern-tray " + (globalReducer.trayOpen.calculators ? "tool-pattern-tray-open" : "")}>
      <span className="clickable exit-button" onClick={(e)=>{ dispatch(setTrayOpen({tray: "calculators", open: false} )) }}>
        <i className="fal fa-times fa-3x"/>
      </span>
      <div className="container-fluid">

        <div className="row row-push-down">
          <div className="col-md-6">
            <CustomField
              value={this.state.search}
              name="search"
              type='text'
              placeholder='search templates'
              icon="fa-search"
              onChange={(e)=> { that.setState({search: e}) }}
              form={false}
              />
          </div>
          <div className="col-md-6">
            <br/><br/>
            <div className="div-info-text-large-pad">
              <p className="lead text-700 no-margin-bottom">What's a template?</p>
              <p className="no-margin-bottom">
                Templates let you generate the perfect pattern for your needs by controlling the variables that matter. Just edit a few input fields and create super quick PAT file variations of the most commonly used patterns. 
              </p>
            </div>
          </div>
        </div>

        {
          (this.state.search && !hasSearchResults) && <div className="row">
            <div className="col-md-12">
              <p className="text-lg">
                There aren't any patterns that match the current search and filters.<br/>
                Have something you're looking for? <Link to="/contact">Get in touch</Link> and we'll help make it happen.
              </p>
            </div>
          </div>
        }


        {
          patternManager.tryingToGetOfficialCalculators && 
          <div className="row">
            <div className="col-md-4">
              <span className="text-muted list-item">
                <i className="far fa-spinner-third fa-spin fa-fw fa-lg"/> Loading...
              </span>
            </div>
          </div>
        }

        {
          this.state.search && <div className="row">
            {
              patternManager.officialCalculators.map((p, i) => {
                if(patternManager.cache[p].name.toLowerCase().indexOf(that.state.search.toLowerCase()) > -1){
                  return calculatorThumbnail(p, i);
                }
              })
            }
          </div>
        }

        {
          !this.state.search && <div className="row">
            {
              patternManager.officialCalculators.map((p, i) => {
                if(patternManager.cache[p].name.toLowerCase().indexOf(that.state.search.toLowerCase()) > -1){
                  return calculatorThumbnail(p, i);
                }
              })
            }
          </div>
        }
      </div>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { 
    globalReducer, patternManager, user, team
    //...
  } = state;

  return {
    globalReducer, patternManager, user, team
    //...
  }
}

export default connect(mapStateToProps)(ToolCalculatorTray);


// WEBPACK FOOTER //
// ./src/components/ToolTrays/ToolCalculatorTray.js